import DownloadPDF from './DownloadPDF';

export default DownloadPDF;
